module.exports = __webpack_public_path__ + "img/fl.9796e860.png";